
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/privateAppsPanel/components/appReleaseNotes/appReleaseNotes.scss.css.virtualfile';
        module.exports = {"title":"_title_askho_1","content":"_content_askho_4","container":"_container_askho_7"};